// Generated once from the retired styles/tokens.css; this file is now the source of truth for
// every colour in the app. Four palettes: dark (default), light, and the accessible version in
// its light and dark schemes (it follows the device scheme).
export const dark = {
  bg: "#1b1015",
  bg2: "#140b10",
  surface: "#251820",
  surface2: "#30202a",
  surface3: "#3b2a34",
  line: "rgba(255, 221, 232, 0.1)",
  lineStrong: "rgba(255, 221, 232, 0.22)",
  lineInput: "rgba(255, 221, 232, 0.38)",
  ink: "#f7eef2",
  text: "#f7eef2",
  textDim: "#d3bbc6",
  textFaint: "#ad93a0",
  accent: "#e4b556",
  accentInk: "#2a1119",
  accentSoft: "rgba(228, 181, 86, 0.14)",
  accentLine: "rgba(228, 181, 86, 0.5)",
  highlight: "#e4b556",
  garnet: "#d8617f",
  info: "#93c6ef",
  lilac: "#cfa9ec",
  sage: "#9fd6a7",
  ready: "#8fd39b",
  readyBg: "rgba(90, 190, 115, 0.16)",
  wait: "#f0b86f",
  waitBg: "rgba(242, 183, 109, 0.14)",
  error: "#f29a87",
  errorBg: "rgba(244, 147, 125, 0.14)",
  wineWhite: "#efe3a4",
  wineRose: "#f0b3ad",
  wineRed: "#8b1f38",
  wineSparkling: "#efe3a4",
  wineFortified: "#6e1a30",
  bottleGlass: "rgba(255, 255, 255, 0.07)",
  bottleCork: "#d9b98a",
  bottleCorkInk: "#8a6a43",
  bottlePaper: "#fbf7ee",
  hueLemonGreen: "#c3d94a",
  hueLemon: "#e8d94a",
  hueGold: "#e0a72e",
  hueAmber: "#c97f22",
  hueBrown: "#7a4a24",
  huePink: "#e8a4b5",
  hueSalmon: "#e88a68",
  hueOrange: "#e0692f",
  huePurple: "#5c1a45",
  hueRuby: "#a0132f",
  hueGarnet: "#7a1424",
  hueTawny: "#9a5325",
  // The aroma lexicon's family colours belong to the lexicon, not to a theme: the same in all four.
  aromaFloral: "#c9a6e0",
  aromaGreenFruit: "#9ccf6e",
  aromaCitrus: "#e8d34a",
  aromaStoneFruit: "#f2b27a",
  aromaTropicalFruit: "#f29d3c",
  aromaRedFruit: "#e05566",
  aromaBlackFruit: "#5b2a6e",
  aromaHerbaceous: "#5fa85c",
  aromaHerbal: "#8fb59b",
  aromaSpiceFresh: "#c0552f",
  aromaMineral: "#9fb1c2",
  aromaYeast: "#d9c38f",
  aromaMalolactic: "#f0e0b0",
  aromaOak: "#a86b3c",
  aromaOxidative: "#8c6a4a",
  aromaFruitDevelopment: "#8e4b6a",
  aromaBottleAge: "#6b5a3e",
  elev1: "#3d6b5e",
  elev2: "#5f8f6c",
  elev3: "#9cb575",
  elev4: "#d6c37e",
  elev5: "#e9d9b8",
} as const;

export const light = {
  bg: "#fdfbf7",
  bg2: "#f6f1e9",
  surface: "#ffffff",
  surface2: "#faf6ef",
  surface3: "#f0e8db",
  line: "rgba(42, 17, 25, 0.1)",
  lineStrong: "rgba(42, 17, 25, 0.22)",
  lineInput: "rgba(42, 17, 25, 0.42)",
  ink: "#2a1119",
  text: "#241318",
  textDim: "#655059",
  textFaint: "#7f6b74",
  accent: "#7b1e3a",
  accentInk: "#ffffff",
  accentSoft: "rgba(123, 30, 58, 0.08)",
  accentLine: "rgba(123, 30, 58, 0.4)",
  highlight: "#8f6412",
  garnet: "#7b1e3a",
  info: "#2f6f9f",
  lilac: "#6a4a94",
  sage: "#3f7a4c",
  ready: "#2f7a42",
  readyBg: "rgba(47, 122, 66, 0.1)",
  wait: "#8d5c12",
  waitBg: "rgba(168, 112, 31, 0.1)",
  error: "#b23a3a",
  errorBg: "rgba(178, 58, 58, 0.08)",
  wineWhite: "#e6d27a",
  wineRose: "#e59a93",
  wineRed: "#7b1e3a",
  wineSparkling: "#e6d27a",
  wineFortified: "#5a1424",
  bottleGlass: "rgba(42, 17, 25, 0.04)",
  bottleCork: "#d4b283",
  bottleCorkInk: "#8a6a43",
  bottlePaper: "#fffdf8",
  hueLemonGreen: "#c3d94a",
  hueLemon: "#e8d94a",
  hueGold: "#e0a72e",
  hueAmber: "#c97f22",
  hueBrown: "#7a4a24",
  huePink: "#e8a4b5",
  hueSalmon: "#e88a68",
  hueOrange: "#e0692f",
  huePurple: "#5c1a45",
  hueRuby: "#a0132f",
  hueGarnet: "#7a1424",
  hueTawny: "#9a5325",
  aromaFloral: "#c9a6e0",
  aromaGreenFruit: "#9ccf6e",
  aromaCitrus: "#e8d34a",
  aromaStoneFruit: "#f2b27a",
  aromaTropicalFruit: "#f29d3c",
  aromaRedFruit: "#e05566",
  aromaBlackFruit: "#5b2a6e",
  aromaHerbaceous: "#5fa85c",
  aromaHerbal: "#8fb59b",
  aromaSpiceFresh: "#c0552f",
  aromaMineral: "#9fb1c2",
  aromaYeast: "#d9c38f",
  aromaMalolactic: "#f0e0b0",
  aromaOak: "#a86b3c",
  aromaOxidative: "#8c6a4a",
  aromaFruitDevelopment: "#8e4b6a",
  aromaBottleAge: "#6b5a3e",
  elev1: "#4c7c6b",
  elev2: "#7aa47f",
  elev3: "#b7c98a",
  elev4: "#e2d08b",
  elev5: "#f1e7cf",
} as const;

export const a11yLight = {
  bg: "#ffffff",
  bg2: "#f4f4f4",
  surface: "#ffffff",
  surface2: "#f2f2f2",
  surface3: "#e2e2e2",
  line: "#6b6b6b",
  lineStrong: "#1a1a1a",
  lineInput: "#1a1a1a",
  ink: "#111111",
  text: "#111111",
  textDim: "#2e2e2e",
  textFaint: "#474747",
  accent: "#5a0f29",
  accentInk: "#ffffff",
  accentSoft: "#f3e3e8",
  accentLine: "#5a0f29",
  highlight: "#5a4300",
  garnet: "#5a0f29",
  info: "#0a4a78",
  lilac: "#4a2a7a",
  sage: "#1f5a2e",
  ready: "#145a2a",
  readyBg: "#e3f1e6",
  wait: "#5c4300",
  waitBg: "#f5ecd4",
  error: "#8a1c1c",
  errorBg: "#f7e1e1",
  wineWhite: "#e6d27a",
  wineRose: "#e59a93",
  wineRed: "#7b1e3a",
  wineSparkling: "#e6d27a",
  wineFortified: "#5a1424",
  bottleGlass: "rgba(0, 0, 0, 0.06)",
  bottleCork: "#c9a26f",
  bottleCorkInk: "#4a3414",
  bottlePaper: "#ffffff",
  hueLemonGreen: "#c3d94a",
  hueLemon: "#e8d94a",
  hueGold: "#e0a72e",
  hueAmber: "#c97f22",
  hueBrown: "#7a4a24",
  huePink: "#e8a4b5",
  hueSalmon: "#e88a68",
  hueOrange: "#e0692f",
  huePurple: "#5c1a45",
  hueRuby: "#a0132f",
  hueGarnet: "#7a1424",
  hueTawny: "#9a5325",
  aromaFloral: "#c9a6e0",
  aromaGreenFruit: "#9ccf6e",
  aromaCitrus: "#e8d34a",
  aromaStoneFruit: "#f2b27a",
  aromaTropicalFruit: "#f29d3c",
  aromaRedFruit: "#e05566",
  aromaBlackFruit: "#5b2a6e",
  aromaHerbaceous: "#5fa85c",
  aromaHerbal: "#8fb59b",
  aromaSpiceFresh: "#c0552f",
  aromaMineral: "#9fb1c2",
  aromaYeast: "#d9c38f",
  aromaMalolactic: "#f0e0b0",
  aromaOak: "#a86b3c",
  aromaOxidative: "#8c6a4a",
  aromaFruitDevelopment: "#8e4b6a",
  aromaBottleAge: "#6b5a3e",
  elev1: "#1f4d3f",
  elev2: "#3f7a55",
  elev3: "#7faa5b",
  elev4: "#c9b35a",
  elev5: "#efe0b0",
} as const;

export const a11yDark = {
  bg: "#000000",
  bg2: "#0a0a0a",
  surface: "#0d0d0d",
  surface2: "#1a1a1a",
  surface3: "#2a2a2a",
  line: "#9a9a9a",
  lineStrong: "#ffffff",
  lineInput: "#ffffff",
  ink: "#ffffff",
  text: "#ffffff",
  textDim: "#e8e8e8",
  textFaint: "#d0d0d0",
  accent: "#ffd166",
  accentInk: "#000000",
  accentSoft: "#3a2f10",
  accentLine: "#ffd166",
  highlight: "#ffd166",
  garnet: "#ff8fa3",
  info: "#8fd3ff",
  lilac: "#d6b8ff",
  sage: "#9fe0a8",
  ready: "#9fe8ac",
  readyBg: "#11331a",
  wait: "#ffd27f",
  waitBg: "#3a2d08",
  error: "#ff9b9b",
  errorBg: "#3d1111",
  wineWhite: "#efe3a4",
  wineRose: "#f0b3ad",
  wineRed: "#a3284a",
  wineSparkling: "#efe3a4",
  wineFortified: "#8a2440",
  bottleGlass: "rgba(255, 255, 255, 0.1)",
  bottleCork: "#d9b98a",
  bottleCorkInk: "#6b4f2a",
  bottlePaper: "#ffffff",
  hueLemonGreen: "#c3d94a",
  hueLemon: "#e8d94a",
  hueGold: "#e0a72e",
  hueAmber: "#c97f22",
  hueBrown: "#7a4a24",
  huePink: "#e8a4b5",
  hueSalmon: "#e88a68",
  hueOrange: "#e0692f",
  huePurple: "#5c1a45",
  hueRuby: "#a0132f",
  hueGarnet: "#7a1424",
  hueTawny: "#9a5325",
  aromaFloral: "#c9a6e0",
  aromaGreenFruit: "#9ccf6e",
  aromaCitrus: "#e8d34a",
  aromaStoneFruit: "#f2b27a",
  aromaTropicalFruit: "#f29d3c",
  aromaRedFruit: "#e05566",
  aromaBlackFruit: "#5b2a6e",
  aromaHerbaceous: "#5fa85c",
  aromaHerbal: "#8fb59b",
  aromaSpiceFresh: "#c0552f",
  aromaMineral: "#9fb1c2",
  aromaYeast: "#d9c38f",
  aromaMalolactic: "#f0e0b0",
  aromaOak: "#a86b3c",
  aromaOxidative: "#8c6a4a",
  aromaFruitDevelopment: "#8e4b6a",
  aromaBottleAge: "#6b5a3e",
  elev1: "#2f6b5a",
  elev2: "#4f9a6a",
  elev3: "#9ccb6e",
  elev4: "#e3cf6a",
  elev5: "#fff0c2",
} as const;

/** A key every palette has; components name a colour by it. */
export type PaletteKey = keyof typeof dark;
